<template>
    <div class="col-12">
        <slot name="id"></slot>

        <slot name="password"></slot>

        <slot name="forgot_password"></slot>

        <div class="form-row mt-5">
            <div
                class="col-xs-12 col-sm-6 col-md-6 col-lg-6 m-auto">
                <div class="form-group">
                    <input type="submit" class="btn btn-primary btn-block btn-lg"
                           :value="$lang('Zaloguj')">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Autocomplete from '@trevoreyre/autocomplete-vue'

    export default {
        name: 'quatra-login-form',
        components: {Autocomplete},
        methods: {
            showHelp() {
                const link = document.getElementById('help_link');
                const div = document.getElementById('help');
                div.hidden = !div.hidden;
                if(link.classList.contains('fa-arrow-circle-right')) {
                    link.classList.remove('fa-arrow-circle-right');
                    link.classList.add('fa-arrow-circle-down');
                } else {
                    link.classList.remove('fa-arrow-circle-down');
                    link.classList.add('fa-arrow-circle-right');
                }
            }
        },
    }
</script>
